import * as React from 'react';
import FeatureFlagsHeader from './FeatureFlags/FeatureFlagsHeader';
import FeatureFlagsList from './FeatureFlags/FeatureFlagsList';
import HeaderFlexPane from './HeaderFlexPane';
var FeatureFlagsPane = function (props) {
    return (React.createElement(HeaderFlexPane, { title: "Feature Flags", content: React.createElement("div", null,
            React.createElement(FeatureFlagsHeader, null),
            React.createElement(FeatureFlagsList, null)), onDismiss: props.onDismiss }));
};
export default FeatureFlagsPane;
//# sourceMappingURL=FeatureFlagsPane.js.map